import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { Dialog, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import '../modalDatosIniciales.css';

import { Model } from '../../../../models/model';
import { InvoiceModalNuevo } from '../../../invoices/form/InvoiceModalNuevo';
import { useInvoices } from '../../../../hooks/useInvoices';
import { ComprasModalNuevoGasto } from '../../../compras/form/ComprasModalNuevoGasto';
import { useBuy } from '../../../../hooks/useBuy';
import { FlowSection } from './FlowSection';

export const DialogDetailItemsFlow = ({ open, setOpen, item, tasksList = null, currentTasks = null, refreshObj = null }) => {

    const generalParams = useSelector(state => state.general)
    const generalDetail = generalParams.detail

    const [detailBudget, setDetailBudget] = useState({ id: null })

    const { detailInvoice, initCreateInvoiceFromFlow } = useInvoices()
    const { detailBuy, initCreateBuyFromFlow } = useBuy()

    const [openNewInvoice, setOpenNewInvoice] = useState(false)
    const [openExtendedMode, setOpenExtendedMode] = useState(false)

    const [form, setForm] = useState({
        ...item,
        tipo_flujo: 'ingreso',
        total_proyectado: item?.total_proyectado || 0,
        saldo_por_proyectar: item?.saldo_por_proyectar || 0,
        total_proyectado_egresos: item?.total_proyectado_egresos,
        saldo_por_proyectar_egresos: item?.saldo_por_proyectar_egresos,

        total_facturado: item?.total_facturado,
        total_por_facturar: item?.total_por_facturar,
        total_cobrado: item?.total_cobrado,
        total_por_cobrar: item?.total_por_cobrar,

        total_gastado: item?.total_gasto_real,
        total_por_gastar: item?.total_por_gastar,
        total_pagado: item?.total_pagado,
        total_por_pagar: item?.total_por_pagar
    });

    const handleGetInfoBudget = useCallback(async (budgetId) => {
        const resultsBudget = await Model.getOne({
            url: `budgets/${budgetId}`,
        })

        setDetailBudget(resultsBudget)

        setForm(prev => ({
            ...prev,
            id_ppto: resultsBudget?.id,
            id_cliente: resultsBudget?.id_cliente,
            separacion_miles: resultsBudget?.separacion_miles,
            separacion_decimales: resultsBudget?.separacion_decimales,
            simbolo: resultsBudget?.simbolo,
            id_moneda: resultsBudget?.id_moneda,
            valor_tipo_cambio: resultsBudget?.valor_tipo_cambio
        }))

    }, [])

    const handleLoadRefresh = useCallback(async () => {
        await refreshObj.fn_(refreshObj.filters_)
    }, [refreshObj])

    const handleGetInfoItem = useCallback(async (id) => {

        const results = await Model.getOne({
            url: `budgets-items/${id}`,
        })

        if (results) {
            setForm(prev => ({
                ...prev,
                total_proyectado: results?.total_proyectado || 0,
                saldo_por_proyectar: results?.saldo_por_proyectar || 0,
                total_proyectado_egresos: results?.total_proyectado_egresos || 0,
                saldo_por_proyectar_egresos: results?.saldo_por_proyectar_egresos || 0,

                total_facturado: results?.total_facturado || 0,
                total_por_facturar: results?.total_por_facturar || 0,
                total_cobrado: results?.total_cobrado || 0,
                total_por_cobrar: results?.total_por_cobrar || 0,

                total_gastado: results?.total_gasto_real || 0,
                total_por_gastar: results?.total_por_gastar || 0,
                total_pagado: results?.total_pagado || 0,
                total_por_pagar: results?.total_por_pagar || 0
            }))

        }

    }, [])

    const handleSelectItem = ({ target }) => {
        const itemId = target.value

        if (itemId) {
            const itemFound = detailBudget?.items?.find(it => it.id === itemId)
            setForm({
                ...form,
                id: itemId,
                nombre: itemFound?.nombre,
                precio_subtotal: itemFound?.precio_subtotal || 0,
                total_proyectado: itemFound?.total_proyectado || 0,
                saldo_por_proyectar: itemFound?.saldo_por_proyectar || 0,
                costo_subtotal: itemFound?.costo_subtotal || 0,
                total_proyectado_egresos: itemFound?.total_proyectado_egresos || 0,
                saldo_por_proyectar_egresos: parseFloat(itemFound?.costo_subtotal) - parseFloat(itemFound?.total_proyectado_egresos || 0),

                total_facturado: itemFound?.total_facturado || 0,
                total_por_facturar: itemFound?.total_por_facturar || 0,
                total_cobrado: itemFound?.total_cobrado || 0,
                total_por_cobrar: itemFound?.total_por_cobrar || 0,

                total_gastado: itemFound?.total_gasto_real || 0,
                total_por_gastar: itemFound?.total_por_gastar || 0,
                total_pagado: itemFound?.total_pagado || 0,
                total_por_pagar: itemFound?.total_por_pagar || 0

            })
        }
    }

    const handleOpenNewInvoice = async (flowSelected, flowType) => {

        const infoFlow = {
            ...flowSelected,
            referencia: item?.nombre + " / " + flowSelected.porcentaje_flow + "%"
        }

        if (flowType === 'ingreso') {
            await initCreateInvoiceFromFlow(detailBudget, generalDetail, infoFlow)
            setOpenNewInvoice(true)

        } else {

            const resultTask = await Model.getOne({ url: `tasks/${flowSelected?.id_tarea}` })
            // console.log({ flowSelected })

            const itemsSelected = [{
                id_proveedor: null,
                nombre: (item?.nombre + " / " + resultTask?.nombre).toUpperCase(),
                total_por_gastar: flowSelected?.monto_neto,
                id_titulo: null,
                id_servicio: null,
                id_categoria: item?.id_categoria,
                origen: null,
                id_item_ppto: flowSelected?.id_item_ppto,
            }]

            const params = {
                origen: 'ventas',
                itemsSelected,
                detailBudget,
                generalParams,
                flowSelected
            }

            await initCreateBuyFromFlow(params)
            setOpenExtendedMode(true)

        }

    }

    useEffect(() => {
        if (item?.id_presupuesto) {
            handleGetInfoBudget(item?.id_presupuesto)
        }
    }, [item?.id_presupuesto, handleGetInfoBudget])

    useEffect(() => {
        if (item?.id && detailBudget.id) {
            handleGetInfoItem(item.id)
        }
    }, [detailBudget.id, item?.id, handleGetInfoItem])

    useEffect(() => {
        if (refreshObj) {
            handleLoadRefresh()
        }
    }, [form, refreshObj, handleLoadRefresh])

    return (
        <Dialog
            className='dialogo-auto'
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="simple-dialog-title"
        >
            <div className='ContainerDialogs'>
                <h1 className='TitleModalPresupuesto'>

                    <IconButton
                        style={{ padding: '0', float: 'right' }}
                        aria-label="close"
                        onClick={() => setOpen(false)}
                    >
                        <CloseIcon />
                    </IconButton>

                    <h3 className='mt-3' style={{ fontSize: '16px' }}>Proyección de flujos:</h3>

                    {form.id ?
                        <span style={{ textTransform: 'uppercase', fontSize: '16px' }}>
                            <span className='ms-1'>{form.nombre}</span>
                        </span>
                        :
                        <div>
                            <label>ÍTEM DEL PRESUPUESTO:</label>
                            <select
                                style={{
                                    border: '1px solid lightgray',
                                    padding: '2px',
                                    backgroundColor: 'white',
                                    width: '100%',
                                    borderRadius: '3px',
                                    textAlign: 'left',
                                    textTransform: 'uppercase'
                                }}
                                onChange={handleSelectItem}
                            >
                                <option key="" value="">--seleccionar--</option>
                                {detailBudget?.items?.map(it => (
                                    <option
                                        key={it.id}
                                        selected={it.id === form?.id ? 'selected' : ''}
                                        value={it.id}
                                        style={{ textTransform: 'uppercase' }}
                                    >
                                        {it.nombre}
                                    </option>
                                ))}
                            </select>

                            {/* <select
                                style={{
                                    border: '1px solid lightgray',
                                    padding: '2px',
                                    backgroundColor: 'white',
                                    width: '100%',
                                    borderRadius: '3px',
                                    textAlign: 'left',
                                    textTransform: 'uppercase'
                                }}
                                onChange={handleSelectItem}
                            >
                                <option key="" value="">--</option>
                                {itemsPpto?.map(cat => (
                                    <>
                                        <option
                                            key={cat.id}
                                            selected={cat.id === form?.id ? 'selected' : ''}
                                            value={cat.id}
                                            style={{ textTransform: 'uppercase' }}
                                        >
                                            === {cat.nombre} ===
                                        </option>
                                        {cat?.items.map(it => (
                                            <option
                                                key={it.id}
                                                selected={it.id === form?.id ? 'selected' : ''}
                                                value={it.id}
                                                className='p-2'
                                            >- {it.nombre}
                                            </option>
                                        ))}
                                        <hr />
                                    </>
                                ))}
                            </select> */}

                        </div>
                    }
                </h1>

                <FlowSection
                    form={form}
                    setForm={setForm}
                    handleGetInfoItem={handleGetInfoItem}
                    tasksList={tasksList}
                    currentTasks={currentTasks}
                    handleOpenNewInvoice={handleOpenNewInvoice}
                />

                {openNewInvoice && (
                    <InvoiceModalNuevo
                        title='Nueva factura'
                        open={openNewInvoice}
                        setOpen={setOpenNewInvoice}
                        initialState={detailInvoice}
                        loadIniBudget={() => false}
                    />
                )}

                {openExtendedMode && (
                    <ComprasModalNuevoGasto
                        title='Nuevo gasto'
                        open={openExtendedMode}
                        setOpenExtendedMode={setOpenExtendedMode}
                        initialState={detailBuy}
                        loadIniBudget={() => false}
                    />
                )}

            </div>
        </Dialog>
    )
}

